import { render } from "./TJTS.vue?vue&type=template&id=30135104&scoped=true"
import script from "./TJTS.vue?vue&type=script&lang=js"
export * from "./TJTS.vue?vue&type=script&lang=js"

import "./TJTS.vue?vue&type=style&index=0&id=30135104&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30135104"]])

export default __exports__